/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DesignProfileWrapper_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"HeaderRoot_viewer" | "OverviewRoot_viewer" | "ProjectsRoot_viewer">;
    readonly " $refType": "DesignProfileWrapper_viewer";
};
export type DesignProfileWrapper_viewer$data = DesignProfileWrapper_viewer;
export type DesignProfileWrapper_viewer$key = {
    readonly " $data"?: DesignProfileWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"DesignProfileWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "DesignProfileWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "HeaderRoot_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "OverviewRoot_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ProjectsRoot_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '479f9cedcebdf1a077aaf89936d77dc8';
export default node;
